import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../../shared/services/indexedDb.service';
import { InspectionPlugin } from '../../../shared/models';
import { Observable } from 'rxjs';
import { DataService } from '../../../shared/services';

@Injectable()
export class InstallationReceivedPluginFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateReceivedValues(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    receivedValues: any[],
    propertyName?: string
  ): Observable<InspectionPlugin> {
    receivedValues.forEach((r) => {
      if (!r.Id) {
        r.Id = this.guid();
      }
    });
    return this.updatePluginConfig(inspectionId, pointId, pluginId, receivedValues, propertyName);
  }
}
